import { EnvironmentProviders } from '@angular/core';
import { provideEnvironmentNgxCurrency } from 'ngx-currency';

/**
 * Configuración global de ngx-currency para ARS (Pesos Argentinos)
 * Usa formato de localización argentino:
 * - Separador decimal: ,
 * - Separador de miles: .
 */
export const CURRENCY_ARS_CONFIG = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: '.'
};

/**
 * Configuración global de ngx-currency para USD (Dólares Estadounidenses)
 * Usa formato de localización argentino:
 * - Separador decimal: ,
 * - Separador de miles: .
 */
export const CURRENCY_USD_CONFIG = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.'
};

/**
 * Configuración por defecto: ARS (Pesos Argentinos)
 * Se utiliza para todos los inputs sin configuración específica
 */
export const CURRENCY_DEFAULT_CONFIG = CURRENCY_ARS_CONFIG;

/**
 * Provider para ngx-currency con configuración global
 */
export const CURRENCY_PROVIDERS: EnvironmentProviders =
  provideEnvironmentNgxCurrency(CURRENCY_DEFAULT_CONFIG);
